import cx from "classnames";
import Trophy from "@/components/svg/Trophy";
import { getPickLabel } from "@/utils/horseRacing";
import { pickStyles } from "./utils";
import styles from "./tableCells.module.scss";

interface PickCellProps {
  pick: number | undefined | null;
}

const PickCell = ({ pick }: PickCellProps) => {
  if (!pick) {
    return <></>;
  }
  return (
    <div
      className={cx(
        styles.pickContainer,
        styles.shortened,
        pickStyles(pick ?? undefined)
      )}
    >
      <Trophy />
      <p>{getPickLabel(pick ?? undefined, true)}</p>
    </div>
  );
};

export default PickCell;
